import styles from './HeroTeaserTitle.module.scss';

type Props = {
  title: string;
  titleImage?: string;
  classes?: string;
};

const HeroTeaserTitle = ({ title, titleImage, classes }: Props) => {
  if (!!titleImage) {
    return (
      <div className={`${styles.link} ${classes}`}>
        <div className={styles.titleLogo}>
          <div className="tw-w-full">
            <img src={titleImage} alt={title} />
            <h4 className="tw-sr-only">{title}</h4>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.link} ${classes}`}>
      <h4 className={`${styles.title} ${styles.gutterBottom} tw-line-clamp-3`}>
        {title}
      </h4>
    </div>
  );
};

export default HeroTeaserTitle;
